import { 
    Clock, Heart, Shield, Target, TrendingUp, Activity, Users, UserCheck, 
    UserPlus, Users2, HeartPulse, ShieldCheck, Briefcase, Zap, 
    Car, Bike, Truck, ShieldAlert, Home, Flame, Lock, Store, Factory, 
    Plane, Globe, GraduationCap, Gavel, Cpu, Anchor, Smartphone, Laptop, Sprout, Calendar, Music
} from 'lucide-react';

export const INSURANCE_PRODUCTS = {
    // Life
    'term-insurance': { key: 'ft_life_term', icon: Clock, category: 'ft_life' },
    'whole-life-insurance': { key: 'ft_life_whole', icon: Heart, category: 'ft_life' },
    'endowment-plan': { key: 'ft_life_endow', icon: Target, category: 'ft_life' },
    'money-back-plan': { key: 'ft_life_money', icon: TrendingUp, category: 'ft_life' },
    'ulip': { key: 'ft_life_ulip', icon: Activity, category: 'ft_life' },
    'child-insurance': { key: 'ft_life_child', icon: Users, category: 'ft_life' },
    'pension-plan': { key: 'ft_life_pension', icon: UserCheck, category: 'ft_life' },

    // Health
    'individual-health': { key: 'ft_health_indiv', icon: UserPlus, category: 'ft_health' },
    'family-floater': { key: 'ft_health_family', icon: Users2, category: 'ft_health' },
    'critical-illness': { key: 'ft_health_critical', icon: HeartPulse, category: 'ft_health' },
    'senior-citizen-health': { key: 'ft_health_senior', icon: ShieldCheck, category: 'ft_health' },
    'group-health': { key: 'ft_health_group', icon: Briefcase, category: 'ft_health' },
    'personal-accident': { key: 'ft_health_accident', icon: Zap, category: 'ft_health' },

    // Motor
    'car-insurance': { key: 'ft_motor_car', icon: Car, category: 'ft_motor' },
    'two-wheeler-insurance': { key: 'ft_motor_bike', icon: Bike, category: 'ft_motor' },
    'commercial-vehicle': { key: 'ft_motor_comm', icon: Truck, category: 'ft_motor' },
    'third-party-motor': { key: 'ft_motor_third', icon: ShieldAlert, category: 'ft_motor' },
    'comprehensive-motor': { key: 'ft_motor_compre', icon: ShieldCheck, category: 'ft_motor' },

    // Property
    'home-insurance': { key: 'ft_prop_home', icon: Home, category: 'ft_property' },
    'fire-insurance': { key: 'ft_prop_fire', icon: Flame, category: 'ft_property' },
    'burglary-insurance': { key: 'ft_prop_burg', icon: Lock, category: 'ft_property' },
    'shop-insurance': { key: 'ft_prop_shop', icon: Store, category: 'ft_property' },
    'industrial-insurance': { key: 'ft_prop_indus', icon: Factory, category: 'ft_property' },

    // Travel
    'domestic-travel': { key: 'ft_travel_dom', icon: Plane, category: 'ft_travel' },
    'international-travel': { key: 'ft_travel_intl', icon: Globe, category: 'ft_travel' },
    'student-travel': { key: 'ft_travel_stud', icon: GraduationCap, category: 'ft_travel' },
    'family-travel': { key: 'ft_travel_fam', icon: Users, category: 'ft_travel' },

    // Business
    'liability-insurance': { key: 'ft_biz_liab', icon: Gavel, category: 'ft_business' },
    'professional-indemnity': { key: 'ft_biz_indem', icon: ShieldCheck, category: 'ft_business' },
    'cyber-insurance': { key: 'ft_biz_cyber', icon: Cpu, category: 'ft_business' },
    'marine-insurance': { key: 'ft_biz_marine', icon: Anchor, category: 'ft_business' },
    'workmen-compensation': { key: 'ft_biz_comp', icon: Users, category: 'ft_business' },

    // Others
    'mobile-insurance': { key: 'ft_oth_mobile', icon: Smartphone, category: 'ft_others' },
    'gadget-insurance': { key: 'ft_oth_gadget', icon: Laptop, category: 'ft_others' },
    'pet-insurance': { key: 'ft_oth_pet', icon: Heart, category: 'ft_others' },
    'crop-insurance': { key: 'ft_oth_crop', icon: Sprout, category: 'ft_others' },
    'event-insurance': { key: 'ft_oth_event', icon: Calendar, category: 'ft_others' },
    'wedding-insurance': { key: 'ft_oth_wed', icon: Music, category: 'ft_others' }
};
